import Axios from 'axios';
import { AccessTokenKey, RefreshTokenKey } from '../contexts/Authentication';
import settings from '../settings';

const Auth = {
  login: async (email: string, pass: string) => {
    return await Axios.post(settings.OpenIdProvider.login, { email, pass })
      .then(res => res.data)
      .then(({ refreshToken, accessToken }) => {
        localStorage.setItem(AccessTokenKey, accessToken);
        localStorage.setItem(RefreshTokenKey, refreshToken);
        return true;
      })
      .catch(() => false);
  },

  logout: () => {
    localStorage.removeItem(AccessTokenKey);
    localStorage.removeItem(RefreshTokenKey);
  },

  refresh: async () => {
    localStorage.removeItem(AccessTokenKey);
    return await Axios.post(settings.OpenIdProvider.refresh, { refreshToken: localStorage.getItem(RefreshTokenKey) })
      .then(res => res.data)
      .then(({ accessToken }) => {
        localStorage.setItem(AccessTokenKey, accessToken);
        return true;
      })
      .catch(() => {
        localStorage.removeItem(RefreshTokenKey);
        return false;
      })
  }
}

export default Auth;